<!-- 个人中心 -->
<template>
  <div id="user">
    <div class="main">
      <div>
        <!-- 头部地理位置和搜索框 -->
        <div class="head">
          <!-- 顶部NavBar 开始 -->
          <van-nav-bar
            :title="$t('person.title')"
            style="background-color: rgba(255,255,255,0);"
            @click-left="onClickLeft"
          />
        </div>
      </div>
      <div class="outboxstyle">
        <div style="font-size:16px;background:#fff;border-radius:16px 16px 0px 0px;padding:20px">
          <div class="box">
            <van-row>
              <van-col>
                <div
                  class="img-box"
                >
                  <img :src="imageL[5]" style="width:40px; height:40px;" class="img">
                </div>
              </van-col>
              <van-col>
                <div class="text-box">
                  <p>{{ $t('person.account') }} <span> {{ user.accountNum }}</span></p>
                  <p>{{ $t('person.name') }} <span>{{ user.name }}</span></p>
                  <p>{{ $t('person.id') }}<span>{{ user.idserial }}</span></p>
                  <p>{{ $t('person.college') }}<span>{{ user.deptName }}</span></p>
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
        <div style="margin-top:20px;">
          <van-cell :title="$t('person.change-password')" :icon="imageL[0]" is-link @click="passwordClick" />
          <van-cell :title="$t('person.toast-notifier')" :icon="imageL[1]" is-link />
          <van-cell :title="$t('person.invoice-title')" :icon="imageL[2]" is-link />
          <van-cell :title="$t('person.request-parcel')" :icon="imageL[3]" is-link @click="toTicket" />
          <van-cell :title="$t('person.user-guide')" :icon="imageL[4]" is-link />
          <van-cell :title="$t('person.refund-account')" :icon="imageL[6]" is-link @click="refundApplication" />
          <van-cell :title="$t('person.fun-bill')" :icon="imageL[7]" is-link @click="more" />
          <van-cell :title="language" :icon="imageL[8]" @click="languageChange" />
        </div>
        <div class="bottom">
          <van-button type="info" size="large" class="bottombutton" @click="dealwith">{{ $t('person.log-out') }}</van-button>
        </div>
      </div>
      <!-- 回到顶部按钮 -->
      <v-top />
    </div>
    <ReiTabbar v-if="hackReset" ref="child" />
  </div>
</template>
<script>
import store from '@/store'
import ReiTabbar from '../components/ReiTabbar.vue'
import { findUserInfoByAccountNum } from '@/api/password'

export default {
  name: 'Password',
  components: {
    ReiTabbar
  },
  data() {
    return {
      hackReset: true,
      language: '',
      user: {
        accountNum: '',
        name: '',
        idserial: '',
        deptName: ''
      },
      imageL: [
        require('../../assets/newImages/passwoed.png'),
        require('../../assets/newImages/notice.png'),
        require('../../assets/newImages/reim.png'),
        require('../../assets/newImages/gotoreim.png'),
        require('../../assets/newImages/usersuggestion.png'),
        require('../../assets/newImages/user.png'),
        require('../../assets/newImages/refound.png'),
        require('../../assets/newImages/feature2.png'),
        require('../../assets/newImages/language.png')
      ]
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background: #F5F5F5')
  },
  mounted() {
    this.init()
    this.languageInit()
    // console.log(this.$store.state.user, 'user')
  },
  methods: {
    //  语言版本初始化
    languageInit() {
      if (window.localStorage.getItem('language') === 'cn') {
        this.language = 'Language switch to English'
      } else {
        this.language = '切换成中文'
      }
    },
    //  语言版本切换
    languageChange() {
      console.log(window.localStorage.language)
      if (window.localStorage.getItem('language') === 'cn') {
        window.localStorage.setItem('language', 'en')
        this.$i18n.locale = window.localStorage.getItem('language')
        this.language = '切换成中文'
        this.$Local('en')
      } else if (window.localStorage.getItem('language') === 'en') {
        window.localStorage.setItem('language', 'cn')
        this.$i18n.locale = window.localStorage.getItem('language')
        this.language = 'Language switch to English'
        this.$Local('cn')
      }
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true
      })
    },
    passwordClick() {
      this.$router.push({ path: 'password' })
    },
    refundApplication() {
      this.$router.push({ path: 'refundApplication' })
    },
    more() {
      this.$router.push({ path: 'more' })
    },
    init() {
      const accountNum = this.$store.state.user.accountNum || localStorage.getItem('accountNum')
      const schoolCode = this.$store.state.settings.schoolCode
      const dataSource = this.$store.state.settings.dataSource
      findUserInfoByAccountNum(accountNum, schoolCode, dataSource).then(res => {
        this.user.accountNum = res.data.accountNum
        this.user.name = res.data.name
        this.user.idserial = res.data.idserial
        this.user.deptName = res.data.deptName
      })
    },
    toTicket() {
      // this.$router.push({ path: '/progressTracking' })
    },
    // 返回
    onClickLeft() {
      // this.$router.push({ path: '/todo' })
      // this.$router.go(-1)
    },
    // 带参数跳转页面
    dealwith(item) {
      this.$router.push({
        path: '/login'
      })
      store.dispatch('user/logout').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>
<style scoped lang="scss">
    #user {
        .van-cell {
            line-height: 30px;
        }

        .van-icon__image {
            width: 40px;
            height: 30px;
        }

        position: relative;
        background-color: #eff6ff;

        .head {
            height: 84px;
            width: 100%;
            background: linear-gradient(135deg, #3793e5 0%, #4046a6 100%);
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }

    .outboxstyle {
        // padding: 0px 10px 10px 10px;
        background-color: #F5F5F5;
        border-radius: 10px;
        margin-top: -20px;
        margin-bottom: 100px;
        width: 100%;
        height: 100%;
    }

    .boxstyle {
        margin: 10px 15px 0 15px;
        background-color: #ffffff;
        border: 1px white solid;
        border-radius: 10px;
        box-shadow: 0px 4px 10px #dde9f3;

        p {
            font-size: 16px;
            font-weight: 700;
            margin: 20px;
        }
    }

    .buttontext {
        width: 90px;
        border-radius: 5px
    }

    .bottom {
        width: 100%;
        background: #ffffff;
        height: 80px;
        margin-top: 20px;
    }

    .bottombutton {
        margin: 20px;
        width: 90%;
        height: 40px;
    }

    .van-cell__value {
        span {
            color: #333333;
        }
    }

    #totalpay {
        .van-cell__value {
            span {
                color: #3BA4F2;
            }
        }
    }
</style>
<style>
    .van-nav-bar .van-icon {
        color: #ffffff;
    }

    .van-nav-bar__title {
        color: #ffffff;
    }

    .van-nav-bar__text {
        color: #ffffff;
    }

    [class*='van-hairline']::after {
        border: none;
    }

    .van-nav-bar {
        height: 80px;
    }
</style>
<style lang="scss" scoped>
    .main {
        margin-bottom: 50px;
    }

    .box {
        padding: 0 5%;
        height: 120px;
        background: linear-gradient(135deg, rgba(55, 147, 229, 1) 0%, rgba(61, 105, 199, 1) 100%);
        border-radius: 12px;
    }

    .img-box {
        width: 60px;
        height: 60px;
        border: 1px solid #ffffff;
        background: #fff;
        border-radius: 50%;
        margin-top: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .text-box {
        margin-top: 20px;
        margin-left: 20px;
        width: 100%;
        p {
            font-size: 14px;
            line-height: 30px;
            height: 20px;
            color: rgba(216, 235, 244, 1);

            span {
                color: #FFFFFF;
            }
        }
    }
</style>
